import { ORIGINS, PAGES, originUrlMap, DEPLOYED_ENVIRONMENT } from '../../components/PageWrapper/Navigation/pages.js';

var shopLocaleMap = {
  // Austria
  de_AT: 'de_at',
  // Australia
  en_AU: 'en_au',
  // Belgium
  fr_BE: 'fr_be',
  nl_BE: 'nl_be',
  // Canada
  en_CA: 'en_ca',
  fr_CA: 'fr_ca',
  // China
  zh_CN: '',
  // Denmark
  da_DK: 'da_dk',
  // Finland
  fi_FI: 'fi_fi',
  // France
  fr_FR: 'fr_fr',
  // Germany
  de_DE: 'de_de',
  // Hong Kong
  zh_HK: 'zh_hk',
  // Iceland
  is_IS: 'is_is',
  // Ireland
  en_IE: 'en_ie',
  // Italia
  it_IT: 'it_IT',
  // Japan
  ja_JP: 'ja_jp',
  // Korea
  ko_KR: 'ko_kr',
  // Luxembourg
  de_LU: 'de_lu',
  fr_LU: 'fr_lu',
  // Macao
  zh_MO: 'zh_mo',
  // Netherlands
  nl_NL: 'nl_nl',
  // New Zealand
  en_NZ: 'en_nz',
  // Norway
  no_NO: 'no_no',
  // Poland
  pl_PL: 'pl_pl',
  // Portugal
  pt_PT: 'pt_pt',
  // Singapore
  en_SG: 'en_sg',
  // Spain
  es_ES: 'es_es',
  // Sweden
  sv_SE: 'sv_se',
  // Switzerland
  de_CH: 'de_ch',
  fr_CH: 'fr_ch',
  it_CH: 'it_ch',
  // Taiwan
  zh_TW: 'zh_tw',
  // United Kingdom
  en_GB: 'en_gb',
  // United States
  en_US: ''
};
var getShopLocale = function getShopLocale(locale) {
  if (locale === 'en_US') {
    return '';
  }
  return shopLocaleMap[locale] || null;
};
var formatLocale = function formatLocale(locale) {
  var parts = (locale || '').split('_');
  if (parts.length !== 2) {
    return locale;
  }
  return "".concat(parts[0], "_").concat(parts[1].toUpperCase());
};
var getNavLink = function getNavLink(currentPage, targetPage, locale) {
  var localizeUrl = '';
  var query = '';
  if (locale !== 'en_US' && locale !== 'zh_CN') {
    if (targetPage.ORIGIN !== ORIGINS.SHOP) {
      localizeUrl = "/".concat(locale);
    } else if (getShopLocale(locale)) {
      // make sure the shop locale exists, otherwise dont include one
      localizeUrl = "/".concat(getShopLocale(locale));
    }
  }
  var origin = window.location.origin;
  // same orign
  if (currentPage.ORIGIN === targetPage.ORIGIN) {
    // same react app
    if (currentPage.BASE_ROUTE === targetPage.BASE_ROUTE) {
      return "".concat(targetPage.ROUTE);
    }
    // move locale to query for sign out
    if (targetPage.NAME === PAGES.SIGN_OUT.NAME) {
      query += "&locale=".concat(locale);
      localizeUrl = '';
    }
    // different react app
    return "".concat(localizeUrl).concat(targetPage.BASE_ROUTE).concat(targetPage.ROUTE).concat(query);
  }
  // different origin
  var currentPageUrlMap = originUrlMap[currentPage.ORIGIN];
  var targetPageUrlMap = originUrlMap[targetPage.ORIGIN];
  var env = Object.keys(currentPageUrlMap).find(function (key) {
    return currentPageUrlMap[key].includes(origin);
  }) || DEPLOYED_ENVIRONMENT.PROD_US;
  return "".concat(targetPageUrlMap[env]).concat(localizeUrl).concat(targetPage.BASE_ROUTE).concat(targetPage.ROUTE).concat(query);
};

export { formatLocale, getNavLink, getShopLocale, shopLocaleMap };
